

import axios from "axios";
import querystring from 'querystring';
import { useState } from "react";
import { toast,ToastContainer} from "react-toastify";


const AgentSignup = ({handleInput, agent, handleTogglePage}) => {

    const [isSubmitted, setIsSubmitted] = useState(false);
    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            console.log(agent);

            const res = await axios.post(
                `${process.env.REACT_APP_API_URL}request-agent-signup`,
                querystring.stringify(agent)
            );
            if(res.data.success){
                toast.success(res.data.message, {
                    position: "top-center",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: false,
                    draggable: false,
                    progress: undefined,
                    theme: "colored",
                });
                localStorage.setItem('agent_auth_token',res?.data?.token);
                // setTimeout(() => {
                //     history.push('/customer-dashboard');
                // }, 2500)

                return;
            }
            else{
                toast.error(res?.data?.message, {
                    position: "top-center",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: false,
                    draggable: false,
                    progress: undefined,
                    theme: "colored",
                });
                return;
            }

        } catch (error) {
            console.log(error?.response?.data?.message);
            toast.error(error?.response?.data?.message || "Unexpected Error occured. Try again", {
                position: "top-center",
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: "colored",
            });
        }
    }

    return (
        <>
            {/* isSubmitted ?  <div className="thanks-text">Thank you, admin will contact you later </div> */}

            <div className="portal-form-wrapper">
                <form className="portal-form" onSubmit={handleSubmit}>
                    <h3 className="portal-form-heading">Agent Signup</h3>
                    <div className="portal-input-group">
                        <input required name="name" type="text"  placeholder="Enter name..." onChange={handleInput}/>
                        <input required name="email" type="email"  placeholder="Enter email..." onChange={handleInput}/>
                        <input required name="company" type="text"  placeholder="Enter company..." onChange={handleInput}/>
                        <input required name="country" type="text"  placeholder="Enter country..." onChange={handleInput}/>
                        <input required name="phone" type="text" placeholder="Enter phone...." onChange={handleInput}/>
                        <input required name="fax" type="text" placeholder="Enter fax...." onChange={handleInput}/>
                        <input required name="password" type="password" placeholder="Enter password...." onChange={handleInput}/>
                    </div>
                    <div className="w-full text-center my-3">
                        <span>Already have an account?&nbsp; 
                            <span>
                                <a onClick={()=>{handleTogglePage('login')}} className="page-toggle-link">
                                    Login
                                </a> 
                            </span>
                            <span>&nbsp;to access your account.</span>
                        </span>
                    </div>
                    <div className="portal-form-btn-group">
                        <button type="submit">Signup</button>
                    </div>
                </form>
            </div>
        </>
    );



}


export default AgentSignup;